function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useStores } from '../hooks/useStores';
import { GlobalStyle } from '../shared/styleguide/GlobalStyle';
import Layout from '../shared/styleguide/Layout';
import Spinner from '../shared/styleguide/Spinner';
import ClientCredentialsRoutes from './client-credentials/ClientCredentailsRoutes';
import NotFound from './NotFound';
import NotificationProvider from './notification/NotificationProvider';
import RequireAuth from './RequireAuth/RequireAuth';
import RoleManagementRoutes from './roles-management/RoleManagementRoutes';
import { InteractionStatus } from '@azure/msal-browser';
import { MsalProvider, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isSuccessEvent } from '../authConfig';
var UserList = /*#__PURE__*/ React.lazy(function() {
    return import('./UserList');
});
var UserProfile = /*#__PURE__*/ React.lazy(function() {
    return import('./UserProfile');
});
var Pages = observer(function() {
    var authStore = useStores().authStore;
    var _useMsal = useMsal(), instance = _useMsal.instance, inProgress = _useMsal.inProgress;
    var isAuthenticated = useIsAuthenticated();
    useEffect(function() {
        var activeAccount = instance.getActiveAccount();
        if (activeAccount && !authStore.loggedInUser) {
            authStore.getUserData(activeAccount);
        } else {
            var callbackId = instance.addEventCallback(function(event) {
                return _async_to_generator(function() {
                    var authenticationResult, account;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(isSuccessEvent(event) && event.payload && !authStore.loggedInUser)) return [
                                    3,
                                    2
                                ];
                                authenticationResult = event.payload;
                                account = authenticationResult.account;
                                return [
                                    4,
                                    authStore.getUserData(account)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            return function() {
                if (callbackId) {
                    instance.removeEventCallback(callbackId);
                }
            };
        }
    }, [
        authStore,
        instance
    ]);
    if (authStore.isLoading || !isAuthenticated && inProgress !== InteractionStatus.None) return /*#__PURE__*/ _jsx(Spinner, {});
    return /*#__PURE__*/ _jsxs(Routes, {
        children: [
            /*#__PURE__*/ _jsx(Route, {
                path: "/login",
                element: /*#__PURE__*/ _jsx(Navigate, {
                    to: '/user',
                    replace: true
                })
            }),
            /*#__PURE__*/ _jsxs(Route, {
                element: /*#__PURE__*/ _jsx(RequireAuth, {}),
                children: [
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/",
                        element: /*#__PURE__*/ _jsx(Navigate, {
                            replace: true,
                            to: "/user"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Route, {
                        path: "/user",
                        element: /*#__PURE__*/ _jsx(Layout, {}),
                        children: [
                            /*#__PURE__*/ _jsx(Route, {
                                index: true,
                                element: /*#__PURE__*/ _jsx(Suspense, {
                                    fallback: /*#__PURE__*/ _jsx(Spinner, {}),
                                    children: /*#__PURE__*/ _jsx(UserList, {})
                                })
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: ":userId",
                                element: /*#__PURE__*/ _jsx(Suspense, {
                                    fallback: /*#__PURE__*/ _jsx(Spinner, {}),
                                    children: /*#__PURE__*/ _jsx(UserProfile, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        element: /*#__PURE__*/ _jsx(Layout, {}),
                        children: /*#__PURE__*/ _jsx(Route, {
                            path: '/client-credentials/*',
                            element: /*#__PURE__*/ _jsx(ClientCredentialsRoutes, {})
                        })
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        element: /*#__PURE__*/ _jsx(Layout, {}),
                        children: /*#__PURE__*/ _jsx(Route, {
                            path: '/roles-management/*',
                            element: /*#__PURE__*/ _jsx(RoleManagementRoutes, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "*",
                element: /*#__PURE__*/ _jsx(NotFound, {})
            })
        ]
    });
});
function App(param) {
    var instance = param.instance;
    return /*#__PURE__*/ _jsx(MsalProvider, {
        instance: instance,
        children: /*#__PURE__*/ _jsxs(NotificationProvider, {
            children: [
                /*#__PURE__*/ _jsx(GlobalStyle, {}),
                /*#__PURE__*/ _jsx(Pages, {})
            ]
        })
    });
}
export default observer(App);
